import{
  AUDIO,
}from "../const";

var axios = require('axios');

const host = "https://spellingdojo.com/";
const appHost = "https://app.spellingdojo.com/";
//const appHost = "http://inthecloud.ddns.net/users/sergio/spelling/";

const StringCapitalize = function(_string) {
    return _string.charAt(0).toUpperCase() + _string.slice(1);
}

export const GetAudioUrl = (wordsetPid,posInDb, mode = "b") => {
    //var encodedURI = window.encodeURI('http://spellingdojo.com/voice/Play.php?text=' + word + '&voice='+ language+'&type=' + AUDIO.Format);
    var encodedURI = window.encodeURI(host + 'voice/Voice.php?pid=' + wordsetPid + '&type=' + AUDIO.Format + '&a=' + mode + '&w=' + posInDb);
    return encodedURI;
}

//Will format the data from the db
function FormatDbData(_text,p_separator, w_separator, wordsetPid, mode){

    if (_text !== null){
      //Contains every line
      var tempLineArray = _text.split(p_separator);
      var newObject = [];
      //Copy data
      for (var i = 0; i < tempLineArray.length - 1; i++){
          var tempWordArray = tempLineArray[i].split(w_separator);
          var newDataObject = {
            id: tempWordArray[2],
            word: tempWordArray[0],
            sentence: tempWordArray[1],
          };
          //Add url for audio in different modes
          //Only word
          newDataObject.audioUrl = {};
          newDataObject.audioUrl.word = GetAudioUrl(wordsetPid, newDataObject.id, AUDIO.Modes.word);
          newDataObject.audioUrl.sentence = GetAudioUrl(wordsetPid, newDataObject.id, AUDIO.Modes.sentence);
          newDataObject.audioUrl.both = GetAudioUrl(wordsetPid, newDataObject.id, AUDIO.Modes.both);
          newDataObject.audioUrl.bothLoop = GetAudioUrl(wordsetPid, newDataObject.id, AUDIO.Modes.bothLoop);
          newDataObject.audioUrl.spell = GetAudioUrl(wordsetPid, newDataObject.id, AUDIO.Modes.spell);
          newObject.push(newDataObject);
      }
      return newObject;
    }

}

export const FetchWordset = (wordSetPid) => {

  var encodedURI = window.encodeURI(`${appHost}dbdata.php?query=1002&format=text&separator=:&pid=${wordSetPid}`);

  return axios.get(encodedURI)
    .then((response) => {
      return FormatDbData(response.data,"|",":", wordSetPid);
    });
}

export const CheckPid = (pid) => {
  const encodedURI = window.encodeURI(`${appHost}dbdata.php?query=1004&pid=${pid}`);

  return axios.get(encodedURI)
  .then((response) => {
    const resp = response.data.split();
    if (resp[0].length > 0){
      return true;
    }else{
      return false;
    }
  })
}

export const GetLanguage = (wordsetPid) => {

  var encodedURI = window.encodeURI(`${appHost}dbdata.php?query=1004&format=text&pid=${wordsetPid}`);

  return axios.get(encodedURI)
    .then((response) => {
      const res = response.data.split("|");
      //console.log(res);
      return res[0];
    });
}



// WEBPACK FOOTER //
// ./src/utils/api.js